import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* getDiscoverLinkCategories({ payload: { signal, searchQ, curr_page } }) {
  try {

    const { data } = yield call(fetch, {
      api: api.discover.linkCategories,
      params: {
        page: curr_page,
        ...(searchQ && { q: searchQ })
      },
      signal
    });

    const preparedData = {
      dataTable: data.results,
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getDiscoverLinkCategoriesDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getDiscoverLinkCategoriesFailed,
      endpoint: api.discover.linkCategories.url
    });
  }
}

export const getDiscoverLinkCategoriesSaga = takeEvery(types.GET_DISCOVER_LINK_CATEGORIES_REQUEST, getDiscoverLinkCategories);
